<article data-testid="c360-renewal-card" class="c360-card">
  <div class="c360-card__head">
    <div>
      <h3 class="c360-card__title">Renewal history</h3>
    </div>
  </div>
  <div class="c360-card__body">
    <app-admin-dashboard-empty *ngIf="!history?.length" data-testid="c360-renewal-empty" [compact]="true"
                               icon="fa-regular fa-rotate" [title]="'No contract yet'"></app-admin-dashboard-empty>
    <table *ngIf="history?.length" data-testid="c360-renewal-table" class="c360-table">
      <thead>
        <tr>
          <th scope="col">Date</th>
          <th scope="col">Outcome</th>
          <th scope="col" class="c360-num">ARR</th>
          <th scope="col" class="c360-num">Change</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let event of history" data-testid="c360-renewal-row">
          <td class="c360-nowrap">{{ event.date | date:'d MMM y':'UTC' }}</td>
          <td><span data-testid="c360-renewal-outcome" class="c360-pill" [attr.data-tone]="outcomeTone(event.outcome)">{{ event.outcome }}</span></td>
          <td class="c360-num">{{ arrText(event) }}</td>
          <td class="c360-num">{{ changeText(event) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</article>
